import React, {useState, useContext, useEffect} from 'react'
import EditProfile from './Editprofile'
import Addchild from './Addchild'
import Editchild from './Editchild'
import Selectchild from './Selectchild'
import {ThemeContext} from '../Helper/Context'
import useFetch from './useFetch'
// import Moment from 'react-moment';
import moment from 'moment';


const Dashboard = () => {
    const [{response}, dofetch] = useFetch();
    const {mainState, setMainState, setShowLoader,resetState} = useContext(ThemeContext);
    const [editChildId, setEditChildId] = useState({id:null})
    const [dashboardState, setDashboardState] = useState({
        editProfile:false,
        addChild:false,
        selectChild:false,
        editChild:false
    })
    
    console.log(resetState);

    const handleDashboard = (editProfileValue, addChildValue, selectChildValue, editChildValue) =>{
        setDashboardState(prevState=>({
            ...prevState,
            ...prevState.editProfile,editProfile:editProfileValue,
            ...prevState.addChild,addChild:addChildValue,
            ...prevState.selectChild,selectChild:selectChildValue,
            ...prevState.addChild,editChild:editChildValue,
        }))
    }
    const handleEditChild = (e,id) =>{
        // console.log('dashboad id '+id)
        setEditChildId({editChildId, id:id})
    }

    const setLocalStorageForParentDetails = () =>{
        let tempState = {...mainState};
        localStorage.setItem('parentDetails', JSON.stringify(tempState));
    }
    window.scrollTo(0, 0)

    // const handleAddChildren = (child) =>{
        
    // }

    const handleBookClass = (e) =>{
        // console.log('reset data');
        
        // console.log(resetState);
        setShowLoader(true);
        setMainState({...mainState, section:'landing'})
        setLocalStorageForParentDetails();
    }
    
    useEffect(()=>{
        if(response){
            setShowLoader(false);
            let children = response.value
            console.log(children)
            if(children.length > 0){
                
                children.map((child, index)=>{
                    let childObj = {};
                    let date = new Date(child.childMember.birthdate);
                    childObj = {
                        id:child.childMember.id,
                        selected:false,
                        firstName:child.childMember.firstName,
                        lastName:child.childMember.lastName,
                        birthDate:moment(date).format(' YYYY-MM-DD'),
                        gender:child.childMember.sex,
                        phoneNumber:child.childMember.phoneNumber,
                        email:child.childMember.email,
                        citizenship:'Australian',
                        healthIssueDetails:'14 Avenue, 2203'
                    }
                    console.log('came to response')
                    setMainState(prevState=>({
                        ...prevState,
                            children:[...prevState.children,childObj]
                    }))

                    
                    // resetData(mainState)
                    // setResetState(prevState=>({
                    //     ...prevState,
                    //         children:[children,childObj]
                    // }))
                    // setResponse(null)
                    
                    
                })
            }

        }else{
            console.log('came to else')
            if(mainState.children.length < 1){
                let urlparams = "?$filter=parentMemberId eq "+mainState.user.userId+" and childMember/isActive eq true&$expand=childMember";
                // let urlparams = "?$filter=parentMemberId eq "+mainState.user.userId+"&$expand=childMember";
                // let urlparams = "?$filter=parentMemberId eq 51065&$expand=childMember";
                dofetch(mainState.fetchURL, 'MemberRelations', 'MemberRelations.get.odata',urlparams,'');
            }
            // setResetState(tempMainState);
        }
    },[response])

    return (
        <>
        {(!dashboardState.editProfile && !dashboardState.addChild && !dashboardState.editChild) &&
        <div className="prefectgym-dashboard">
            <h2>Welcome {!mainState.user.newUser && 'back'} {mainState.user.firstName +' '+ mainState.user.lastName}</h2>
            {!mainState.user.newUser && mainState.children.filter(e => e.selected === true).length < 1 &&
            <p className="desc">Please <strong>select</strong> or <strong>add a child</strong>, and then you can choose your class time.</p>
            // <p className="desc">Please <strong>select</strong> or <strong>add a child</strong>, and then you can choose your class time. You may also update your details by clicking edit profile.</p>
            }

            {mainState.user.newUser && mainState.children.filter(e => e.selected === true).length < 1 &&
            <p className="desc">Please now add your child.</p>
            }

            {mainState.children.filter(e => e.selected === true).map((child, index)=>{
                return(
                    <p key={index} className="desc">Now let’s enrol {child.firstName} into a class.</p>
                )
            })}
            
            { mainState.children.filter(e => e.selected === true).length > 0 &&
            <>
            <div className="select-children">
                <h3>Selected Child</h3>
                <div className="child-list-wrapper">
                    <ul>
                        {mainState.children.filter(e => e.selected === true).map((child, index)=>{
                        return(
                            <li key={index}>
                                <span>{child.firstName}</span>
                                <div className="action-btns">
                                    <button className="btn btn-border" onClick={e => handleDashboard(false, false, true)}>Update</button>
                                </div>
                            </li>
                            )
                        })}
                        
                    </ul>
                </div>
            </div>
            </>
            }

            <div className="btn-wrapper">

                {mainState.children.filter(e => e.selected === true).length > 0 &&
                <button className="btn btn-wide" onClick={e => handleBookClass()}><i className="fal fa-swimmer"></i>Book class</button>
                }
                
                {mainState.children.length > 0 ? (
                    <>
                    {mainState.children.filter(e => e.selected === true).length < 1 &&
                    <button className="btn btn-wide" onClick={e => handleDashboard(false, false, true)}><i className="fal fa-child"></i>select / Add Child</button>
                    }
                    </>
                ):(
                    <button className="btn btn-wide" onClick={e => handleDashboard(false, true, false)}><i className="fal fa-child"></i>Add Child</button>
                )
                }
                
                
                {/* {!mainState.user.newUser && 
                // <button className="btn btn-border btn-wide" onClick={e => handleDashboard(true, false, false)}><i className="far fa-edit"></i>Edit profile</button>
                <button className="btn btn-border btn-wide"><i className="far fa-edit"></i>Edit profile</button>
                } */}
            </div>
        </div>
        }

        {dashboardState.editProfile &&
        <div className="edit-profile">
            <EditProfile onSubmit={handleDashboard}/>
        </div>
        }

        {dashboardState.addChild &&
        <div className="edit-profile">
            <Addchild onSubmit={handleDashboard}/>
        </div>
        }

        {(dashboardState.selectChild && mainState.children.length > 0) &&
        <div className="edit-profile">
            <Selectchild handleDashboard={handleDashboard} handleEditChild={handleEditChild}/>
        </div>
        }

        {dashboardState.editChild &&
        <div className="edit-profile">
            <Editchild onSubmit={handleDashboard} childId={editChildId} />
        </div>
        }

        </>
    )
}

export default Dashboard
